import { Box, Button, Typography } from '@material-ui/core';
import * as React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import { styles } from './PlansButtonsStyles';
import { useHistory } from 'react-router';
import services from 'src/Api/services';

interface IProps {
    loading: boolean;
    packageData: any;
    handleCheckout: (p: any) => void;
    openSuccessModal: () => void;
}

interface IData {
    stripePrice: string;
    packageTitle: string;
    packageSubtitle: string;
    packageFrequency: string;
    pricePerUser: number;
    checkoutPrice: number;
    displayPrice: string;
    features: [];
    usersQuantity: number;
}

const userName = localStorage.getItem('username');

export const PlansButtons = ({
    loading,
    packageData,
    handleCheckout,
    openSuccessModal,
}: IProps) => {
    const {
        stripePrice,
        packageTitle,
        packageSubtitle,
        packageFrequency,
        pricePerUser,
        checkoutPrice,
        displayPrice,
        features,
        usersQuantity,
    }: IData = packageData;

    const classes = styles();
    const history = useHistory();

    function handleClick() {
        handleCheckout(stripePrice);
    }

    return (
        <Box className={classes.package}>
            <Box className={classes.packageHeadWrapper}>
                <Typography variant='h5' className={classes.packageName}>
                    {packageTitle}
                </Typography>
            </Box>
            <Box className={classes.packageAbout}>
                <Box className={classes.packageContainer}>
                    <Box>

                { packageTitle !== 'Multi-License' && (
                            <Typography variant='h4' className={classes.price}>
                                ${displayPrice}
                            </Typography>
                )}
                    </Box>
                    <Box style={{ textAlign: 'center', marginTop: '10px' }}>

                { packageTitle !== 'Multi-License' && (
                <Typography>{packageSubtitle}</Typography>
                )}

                { packageTitle === 'Multi-License' && (
                <div><Typography style={{ fontSize: '24px' }}>$120 for 3-5 Licenses</Typography>
                <Typography style={{ fontSize: '24px' }}>$110 for 6-8 Licenses</Typography>
                <Typography style={{ fontSize: '24px' }}>$100 for 9+ Licenses</Typography></div>
                )}
                </Box >

                { packageTitle !== 'Multi-License' && (
                    <Button
                        className={classes.chooseButton}
                        disabled={loading}
                        onClick={handleClick}
                    >
                        {'Buy Now'}
                    </Button>
                )}
                { packageTitle === 'Multi-License' && (

                <a href='/report-problem' style={{ color: '#fff', textDecoration: 'none' }}>
                    <Button
                        className={classes.chooseButton}
                        disabled={loading}
                    >
                        {'Conctact Us'}
                    </Button>
                    </a>
                )}
                </Box>
            </Box>
        </Box>
    );
};
